import React from "react";

const Services = () => {
  return (
    <section id="services" className="services">
      <section className="services__section">
        <h2 className="services__section_title serif">Graphic Design</h2>

        <p className="services__section_description">
          Great design makes you memorable. We deliver artwork that underscores
          your brand message and captures potential clients’ attention.
        </p>
      </section>

      <section className="services__section">
        <h2 className="services__section_title serif">Photography</h2>

        <p className="services__section_description">
          Increase your credibility by getting the most stunning, high-quality
          photos that improve your business image.
        </p>
      </section>
    </section>
  );
};

export default Services;
